export default {"src":"/_next/static/media/icon_nav_dd_whitepaper_off.d241b8e3.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};